import { POSType } from '@digilize/shared/definitions/src';

// PAUL-3522: a Kitchen Display never creates an order, it only advances ones another POS took, so it
// is never an answer to "which POS was this ordered at" and does not belong in an order search filter.
export const canPosPlaceOrders = (type: POSType): boolean => type !== POSType.FnbKitchenDisplay;
